import axios from "axios";
import { mapActions } from "vuex";
import { forceDownload } from "../utils/file.utils";

export default {
  data() {
    return {
      generateReportFormDialog: false,
    }
  },

  computed: {
    downloadReportLoading: {
      set(isLoading) {
        this.$store.commit("reports/setDownloadReportLoading", isLoading);
      },
      
      get() {
        return this.$store.state.reports.downloadReportLoading;
      },
    }
  },

  methods: {
    ...mapActions("reports", [
      "generateReport",
    ]),

    downloadReport({ reportID, title, daterange }) {
      this.downloadReportLoading = true;
      this.generateReport({ uuid: reportID, title, daterange })
        .then(url => {
          return axios({
            method: "get",
            url,
            responseType: "arraybuffer",
          })
          .then(res => forceDownload(res, url));
        })
        .then(() => this.downloadReportLoading = false);

      this.$ua.trackEvent('DownloadReport', 'click',
        `${this.currentUser.username || 'User'} downloaded ${reportID}, ${title}`);
    },

    processReport({ reportID, payload }) {
      this.downloadReport({ reportID,  ...payload}); 
      this.generateReportFormDialog = false;
    },
  }
}